import styled from 'styled-components';
import { breakpoints } from '@/layouts/breakpoints';

export const Section = styled.section`
  margin-bottom: 48px;
`;

export const H2 = styled.h2`
  font-size: 28px;
  color: #111;
  margin-bottom: 16px;

  @media (max-width: ${breakpoints.medium}) {
    font-size: 22px;
  }
`;

export const H3 = styled.h3`
  font-size: 20px;
  color: #111;
  margin-top: 24px;
  margin-bottom: 12px;
`;

export const P = styled.p`
  font-size: 16px;
  line-height: 1.7;
  color: #333;
  margin-bottom: 16px;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin: 24px 0;
  font-size: 15px;
  line-height: 1.5;
  color: #333;
  margin-bottom: 48px;

  @media (max-width: ${breakpoints.medium}) {
    font-size: 14px;
    display: block;
    overflow-x: auto;
    white-space: nowrap;
  }
`;

export const THead = styled.thead`
  background: #f8f9fa;
`;

export const TBody = styled.tbody`
`;

export const TR = styled.tr`
  border-bottom: 1px solid #e9ecef;
`;

export const TH = styled.th`
  text-align: left;
  padding: 12px 16px;
  font-weight: 600;
  color: #111;
  white-space: nowrap;
`;

export const TD = styled.td`
  padding: 12px 16px;
  vertical-align: middle;
`;

export const IconCell = styled.div<{ $label?: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  ${({ $label }) => $label && `
    font-size: 13px;
    font-weight: 500;
    color: #999;
    line-height: 1.4;
  `}
`;

export const Callout = styled.blockquote`
  background: #f0f7ff;
  border-left: 4px solid #0066cc;
  padding: 16px 20px;
  margin: 24px 0;
  border-radius: 0 8px 8px 0;
  font-size: 15px;
  line-height: 1.6;
  color: #1a1a1a;

  strong {
    color: #0066cc;
  }
`;

export const CodeBlock = styled.pre`
  background: #1e1e1e;
  color: #d4d4d4;
  padding: 20px;
  border-radius: 8px;
  overflow-x: auto;
  font-size: 14px;
  line-height: 1.5;
  margin: 16px 0;
  font-family: 'SF Mono', Monaco, 'Cascadia Code', 'Roboto Mono', monospace;
`;

export const CTALink = styled.a`
  display: inline-block;
  background: black;
  color: #fff;
  padding: 12px 24px;
  border-radius: 8px;
  font-weight: 600;
  text-decoration: none;
  margin-top: 16px;
  transition-duration: 0.3s;
  &:hover {
    opacity: 0.8;
  }
`;

export const Chart = styled.div`
  margin: 24px 0;
  padding: 24px;
  background: #fafafa;
  border-radius: 12px;
  border: 1px solid #eee;
  margin-bottom: 48px;
`;

export const ChartTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #111;
  margin-bottom: 20px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const ChartRow = styled.div`
  display: grid;
  grid-template-columns: 180px 1fr 130px;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;

  @media (max-width: ${breakpoints.medium}) {
    grid-template-columns: 1fr;
    gap: 4px;
    margin-bottom: 18px;
  }
`;

export const ChartLabel = styled.div`
  font-size: 14px;
  color: #333;
  font-weight: 500;
`;

export const ChartBarTrack = styled.div`
  background: #e9ecef;
  height: 28px;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
`;

export const ChartBar = styled.div<{ $width: number; $color?: string }>`
  height: 100%;
  width: ${({ $width }) => $width}%;
  background: ${({ $color }) => $color || '#0066cc'};
  border-radius: 4px;
  transition: width 0.4s ease;
  min-width: 4px;
`;

export const ChartValue = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #111;
  text-align: right;

  @media (max-width: ${breakpoints.medium}) {
    text-align: left;
  }
`;

export const TimelineContainer = styled.div`
  margin: 24px 0;
  padding: 24px;
  background: #fafafa;
  border-radius: 12px;
  border: 1px solid #eee;
`;

export const TimelineRow = styled.div`
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const TimelineLabel = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: #333;
  margin-bottom: 6px;
`;

export const TimelineTrack = styled.div`
  position: relative;
  height: 32px;
  background: #e9ecef;
  border-radius: 4px;
  overflow: hidden;
`;

export const TimelineFill = styled.div<{ $width: number; $color: string }>`
  height: 100%;
  width: ${({ $width }) => $width}%;
  background: ${({ $color }) => $color};
  display: flex;
  align-items: center;
  padding-left: 10px;
  font-size: 12px;
  color: #fff;
  font-weight: 600;
  border-radius: 4px;
  min-width: 60px;
`;

export const StatGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 16px;
  margin: 24px 0;
`;

export const StatCard = styled.div`
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 12px;
  padding: 20px;

  .value {
    font-size: 28px;
    font-weight: 700;
    color: #111;
    margin-bottom: 4px;
    line-height: 1.1;
  }

  .label {
    font-size: 13px;
    color: #666;
    line-height: 1.4;
  }
`;

export const VerdictBox = styled.div`
  background: #f0fdf4;
  border: 1px solid #86efac;
  border-radius: 12px;
  padding: 24px;
  margin: 24px 0;

  ul {
    margin: 12px 0 0 0;
    padding-left: 20px;
  }

  li {
    margin-bottom: 8px;
    line-height: 1.6;
  }
`;

export const Placeholder = styled.div`
  background: #f5f5f5;
  border: 1px dashed #ccc;
  border-radius: 8px;
  padding: 32px;
  text-align: center;
  color: #999;
  font-size: 14px;
`;
